import * as types from './types'
import { SET_MODAL_DATA } from './types'

export const actions = {
	setModalData: (payload) => ({
		type: types.SET_MODAL_DATA,
		payload,
	}),


	getXmlAction: (payload) => ({
		type: types.GET_XML,
		payload,
	}),
	getXmlActionDone: (payload) => ({
		type: types.GET_XML_DONE,
		payload,
	}),
	getXmlActionFail: (payload) => ({
		type: types.GET_XML_FAIL,
	}),


	sendContractAction: (payload) => ({
		type: types.SEND_CONTRACT,
		payload,
	}),
	sendContractActionDone: (payload) => ({
		type: types.SEND_CONTRACT_DONE,
		payload,
	}),
	sendContractActionFail: (payload) => ({
		type: types.SEND_CONTRACT_FAIL,
	}),


	getContractsAction: (payload) => ({
		type: types.GET_CONTRACTS,
		payload,
	}),
	getContractsActionDone: (payload) => ({
		type: types.GET_CONTRACTS_DONE,
		payload,
	}),
	getContractsActionFail: (payload) => ({
		type: types.GET_CONTRACTS_FAIL,
	}),


	getContractAction: (payload) => ({
		type: types.GET_CONTRACT,
		payload,
	}),
	getContractActionDone: (payload) => ({
		type: types.GET_CONTRACT_DONE,
		payload,
	}),
	getContractActionFail: (payload) => ({
		type: types.GET_CONTRACT_FAIL,
	}),


	sendSubContractAction: (payload) => ({
		type: types.SEND_SUB_CONTRACT,
		payload,
	}),
	sendSubContractActionDone: (payload) => ({
		type: types.SEND_SUB_CONTRACT_DONE,
		payload,
	}),
	sendSubContractActionFail: (payload) => ({
		type: types.SEND_SUB_CONTRACT_FAIL,
	}),


	sendSubGetXmlAction: (payload) => ({
		type: types.SEND_SUB_GET_XML,
		payload,
	}),
	sendSubGetXmlActionDone: (payload) => ({
		type: types.SEND_SUB_GET_XML_DONE,
		payload,
	}),
	sendSubGetXmlActionFail: (payload) => ({
		type: types.SEND_SUB_GET_XML_FAIL,
	}),


	sendDelGetXmlAction: (payload) => ({
		type: types.SEND_DEL_GET_XML,
		payload,
	}),
	sendDelGetXmlActionDone: (payload) => ({
		type: types.SEND_DEL_GET_XML_DONE,
		payload,
	}),
	sendDelGetXmlActionFail: (payload) => ({
		type: types.SEND_DEL_GET_XML_FAIL,
	}),


	sendSubDelGetXmlAction: (payload) => ({
		type: types.SEND_SUB_DEL_GET_XML,
		payload,
	}),
	sendSubDelGetXmlActionDone: (payload) => ({
		type: types.SEND_SUB_DEL_GET_XML_DONE,
		payload,
	}),
	sendSubDelGetXmlActionFail: (payload) => ({
		type: types.SEND_SUB_DEL_GET_XML_FAIL,
	}),


	sendTermGetXmlAction: (payload) => ({
		type: types.SEND_TERM_GET_XML,
		payload,
	}),
	sendTermGetXmlActionDone: (payload) => ({
		type: types.SEND_TERM_GET_XML_DONE,
		payload,
	}),
	sendTermGetXmlActionFail: (payload) => ({
		type: types.SEND_TERM_GET_XML_FAIL,
	}),


	sendTermAction: (payload) => ({
		type: types.SEND_TERM,
		payload,
	}),
	sendTermActionDone: (payload) => ({
		type: types.SEND_TERM_DONE,
		payload,
	}),
	sendTermActionFail: (payload) => ({
		type: types.SEND_TERM_FAIL,
	}),
}
